module.exports = __webpack_public_path__ + "img/zc.5df9a6c3.png";